import { useState, useEffect } from "react";
import axios from "axios";

// カスタムフック useFetchData の定義
const useFetchData = <T,>(url: string, params: object) => { // ジェネリック型 T を追加
    // データを格納するためのステート。初期値は null。
    const [data, setData] = useState<T | null>(null); // T 型を使用

    // ローディング状態を管理するステート。現在は非活性の false設定
    const [loading, setLoading] = useState(false); // 現在は常に false を返す ※制御する場合は、ture

    // エラー情報を格納するためのステート。初期値は null。
    const [error, setError] = useState<Error | null>(null);

    // 副作用フックを使用してデータを取得
    useEffect(() => {
        const fetchData = async () => {
            //setLoading(true); // データ取得開始時にローディングを true に設定
            try {
                // axiosを使用してPOSTリクエストを送信し、データを取得
                const response = await axios.post(url, params, { withCredentials: true });
                setData(response.data); // 取得したデータをステートに設定
            } catch (error) {
                // エラーが発生した場合、エラーステートに設定
                setError(error instanceof Error ? error : new Error(String(error)));
                console.error("Error fetching data:", error); // エラー情報をログに出力
            } 
            // データ取得完了時にローディングを制御する場合はコメントアウト及びtrue に設定
            //finally {
             //   setLoading(true); // データ取得完了時にローディングを false に設定
            //}
        };

        fetchData(); // データ取得関数を実行
    }, [url, JSON.stringify(params)]); // url と params が変更されたときに再実行

    // データ、ローディング状態、エラーを返す
    return { data, loading, error };
};

export default useFetchData; // カスタムフックをエクスポート
